/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.QuizQuestionPartFormat_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.QuizQuestionPartFormat domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum QuizQuestionPartFormat_ {
   /// <summary>
   ///   Fill in the Blank (FB)
   /// </summary>
   Fill_In_Blank = 1,
   /// <summary>
   ///   Multiple Choice Question (Text) (MCQ)
   /// </summary>
   MCQ = 2,
   /// <summary>
   ///   Story (ST)
   /// </summary>
   Story = 3,
   /// <summary>
   ///   Matching Type Easy (MTE)
   /// </summary>
   Matching_Easy = 4,
   /// <summary>
   ///   Matching Type Hard (MTH)
   /// </summary>
   Matching_Hard = 5,
   /// <summary>
   ///   Multiple Choice Question (Image) (MCQ 2CA)
   /// </summary>
   MCQ2CA = 6
}

export const QuizQuestionPartFormats: QuizQuestionPartFormat[] = [
   {
      code: QuizQuestionPartFormat_.Fill_In_Blank,
      literal: 'Fill_In_Blank',
      description: 'Fill in the Blank',
      shortDescription: 'FB',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   },
   {
      code: QuizQuestionPartFormat_.MCQ,
      literal: 'MCQ',
      description: 'Multiple Choice Question (Text)',
      shortDescription: 'MCQ',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   },
   {
      code: QuizQuestionPartFormat_.Story,
      literal: 'Story',
      description: 'Story',
      shortDescription: 'ST',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   },
   {
      code: QuizQuestionPartFormat_.Matching_Easy,
      literal: 'Matching_Easy',
      description: 'Matching Type Easy',
      shortDescription: 'MTE',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   },
   {
      code: QuizQuestionPartFormat_.Matching_Hard,
      literal: 'Matching_Hard',
      description: 'Matching Type Hard',
      shortDescription: 'MTH',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   },
   {
      code: QuizQuestionPartFormat_.MCQ2CA,
      literal: 'MCQ2CA',
      description: 'Multiple Choice Question (Image)',
      shortDescription: 'MCQ 2CA',
      listPriority: 0,

      typeName: "QuizQuestionPartFormat"
   }
]

export class QuizQuestionPartFormat implements IDomainModel {
   code: QuizQuestionPartFormat_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: QuizQuestionPartFormat_): QuizQuestionPartFormat {
      return QuizQuestionPartFormats.find(d => d.code === code)
   }
}
